import React from "react";
import fondoHeader from "../../assets/image/stella/reseller_header.jpg";
import fondobanner from "../../assets/image/stella/reventa_fondo.jpg";
import imagen from "../../assets/image/stella/reventa.png";

function Section1() {

    return (
        <>

            <div className="h-[128px] bg-no-repeat opacity-50 -z-10"
                 style={{
                     backgroundImage: `linear-gradient(180deg, #00000085, #141414), url(${fondoHeader})`,
                 }}></div>
            <section className="relative" id="inicio">
                <div
                    className="absolute inset-0  bg-repeat-y opacity-50 z-0"
                    style={{
                        backgroundImage: `linear-gradient(180deg, #00000085, #141414), url(${fondobanner})`,
                    }}></div>
                <div className="relative container z-10 px-4 py-12 md:py-20 grid grid-cols-1 md:grid-cols-2 max-md:gap-10 items-center">
                    <img alt="reventa magis tv app" width="545" height="536" decoding="async" data-nimg="1"
                         className="h-auto w-full max-w-[460px] filter-[brightness(111%)_contrast(95%)_saturate(85%)_blur(0px)_hue-rotate(160deg)]"
                         src={imagen}/>
                    <div className="text-center text-white"><h1
                        className="text-[28px] md:text-[29px] leading-none font-bold uppercase">Comprar panel de
                        reseller Stella TV</h1><h2 className="mt-4 font-bold uppercase">Conviértete en revendedor de
                        Stella TV</h2><p className="mt-4 text-base leading-relaxed">Adquiere <span
                        className="text-active">créditos de Stella TV</span> a precio mayorista, véndelos a precio
                        minorista y obtén excelentes beneficios. Únete a nuestra red de afiliados y disfruta del mejor
                        servicio de StellaTV en línea.</p>
                        <div className="mt-10">
                            <a href="#paneles" className="btn-primary inline-flex gap-1 px-5 py-3 no-underline">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
                                 fill="currentColor" className="h-5 w-5">
                                <path
                                    d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2M1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0 0 20 4H5.21l-.94-2zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2"></path>
                            </svg>
                            <span className="tracking-wide">VER PRECIOS</span></a></div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Section1;
